function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var market = function market(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "37",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1314 27.3727H12.6863L6.8311 2H0",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7347 20.5416H35.0723L37.9999 6.87936H7.80708",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "14.638",
    cy: "33.2279",
    r: "1.8926",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "32.2037",
    cy: "33.2279",
    r: "1.8926",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "20.7003",
    y1: "7.17507",
    x2: "20.7003",
    y2: "20.8373",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "15.5252",
    y1: "7.17507",
    x2: "15.5252",
    y2: "20.8373",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "25.8754",
    y1: "7.17507",
    x2: "25.8754",
    y2: "20.8373",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "31.0504",
    y1: "7.17507",
    x2: "31.0504",
    y2: "20.8373",
    stroke: "black",
    strokeWidth: "2.07003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3376 13.8802L10.1829 13.8802",
    stroke: "black",
    strokeWidth: "1.69717"
  }));
};

export default market;